import type { FC } from 'react';
import React from 'react';

import type { TSecurityContentBlockDesktop } from '../models';

export const SecurityContentBlockDesktop: FC<
    React.PropsWithChildren<TSecurityContentBlockDesktop>
> = ({ Block, Text, buttonHidden, children, content }) => {
    const Content = () => (
        <Text kind="secondary" styler={{ margin: 0 }} view="component-secondary">
            {content}
        </Text>
    );

    return (
        <Block notPadded styler={{ marginRight: buttonHidden ? 0 : 16 }}>
            {children ?? Content()}
        </Block>
    );
};
